import { render } from "./CreateNewTicket.vue?vue&type=template&id=e7ae7ae8&scoped=true"
import script from "./CreateNewTicket.vue?vue&type=script&lang=js"
export * from "./CreateNewTicket.vue?vue&type=script&lang=js"

import "./CreateNewTicket.vue?vue&type=style&index=0&id=e7ae7ae8&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e7ae7ae8"]])

export default __exports__